module.exports = __webpack_public_path__ + "bd54e200ac3229e3c318ff0816ad29ea.svg";